<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar flat>
                    <v-toolbar-title>{{ game.title }}</v-toolbar-title>

                    <v-spacer/>

                    <game-menu :game="game" @activateTab="activateTab"/>

                    <template v-slot:extension>

                        <v-tabs centered v-model="tab" :show-arrows="false">

                            <v-tab>Reserve</v-tab>
                            <v-tab v-for="(investigatorSession, investigatorSessionIndex) in game.activeInvestigatorSessions"
                                   :key="investigatorSessionIndex">{{
                                investigatorSession.investigator.initial_and_surname }}
                            </v-tab>

                        </v-tabs>
                    </template>
                </v-toolbar>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card flat tile min-height="500px">
                            <v-card-text>
                                <v-row>
                                    <template v-for="(cardBack, cardBackIndex) in game.reserve_cards">
                                        <v-col :key="'reserve' + cardBackIndex"
                                               cols="12"
                                               sm="6"
                                               md="4"
                                               xl="3">
                                            <card :card-back="cardBack"
                                                  :game="game"
                                                  :reserve="true"
                                                  @detachedCard="detachedCard"/>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text
                                       @click="fillReserve"
                                       color="primary">
                                    Fill
                                </v-btn>

                                <v-spacer/>

                                <span class="mr-6">Slots: {{ game.reserve_slots }}</span>

                                <v-btn icon
                                       @click="increaseReserveSlots"
                                       :disabled="game.reserve_slots >= 4"
                                       color="primary">
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn icon
                                       @click="decreaseReserveSlots"
                                       :disabled="game.reserve_slots <= 0"
                                       color="error"
                                       class="mr-6">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            v-for="(investigatorSession, investigatorSessionIndex) in game.activeInvestigatorSessions"
                            :key="investigatorSessionIndex">

                        <v-card flat tile min-height="500px">
                            <v-card-text>
                                <v-row>
                                    <v-col class="text-center">
                                        <v-btn-toggle v-model="cardAttributeTypeSelection[investigatorSessionIndex]"
                                                      tile
                                                      borderless
                                                      multiple>

                                            <template
                                                    v-for="cardType in getFilterPart(investigatorSession, 0)">
                                                <v-tooltip bottom
                                                           v-if="cardType.icon"
                                                           :key="'cardType' + cardType.icon">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn v-on="on" :value="cardType.title">
                                                            <v-icon>{{ cardType.icon }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ cardType.plural_title }}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-btn-toggle>


                                        <v-btn-toggle v-model="cardAttributeTypeSelection[investigatorSessionIndex]"
                                                      tile
                                                      borderless
                                                      multiple>
                                            <template
                                                    v-for="cardType in getFilterPart(investigatorSession, 1)">
                                                <v-tooltip bottom
                                                           v-if="cardType.icon"
                                                           :key="'cardType' + cardType.icon">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn v-on="on" :value="cardType.title">
                                                            <v-icon>{{ cardType.icon }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ cardType.plural_title }}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-btn-toggle>

                                        <v-btn-toggle v-model="cardAttributeTypeSelection[investigatorSessionIndex]"
                                                      tile
                                                      borderless
                                                      multiple>
                                            <template
                                                    v-for="cardType in getFilterPart(investigatorSession, 2)">
                                                <v-tooltip bottom
                                                           v-if="cardType.icon"
                                                           :key="'cardType' + cardType.icon">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn v-on="on" :value="cardType.title">
                                                            <v-icon>{{ cardType.icon }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ cardType.plural_title }}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <template
                                            v-for="(cardBack, cardBackIndex) in filteredCardBacks">
                                        <v-col :key="'cardBack' + cardBackIndex"
                                               cols="12"
                                               sm="6"
                                               md="4"
                                               xl="3">
                                            <card :card-back="cardBack"
                                                  :game="game"
                                                  :investigator="investigatorSession"
                                                  @detachedCard="detachedCard"/>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-card-text>
                        </v-card>

                    </v-tab-item>
                </v-tabs-items>

                <v-card flat tile v-if="tab >= tabOffset">
                    <v-card-actions>
                        <investigator-actions :investigator="game.activeInvestigatorSessions[investigatorSessionIndex]"
                                              :investigator-sessions="game.activeInvestigatorSessions"
                                              @investigatorUpdated="viewGame"/>

                        <pick-card :game="game"
                                   :investigator-session-index="investigatorSessionIndex"
                                   @attachedCard="attachedCard"
                                   v-if="tab >= tabOffset"/>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import GameService from "../services/GameService";
  import InvestigatorSessionService from "../services/InvestigatorSessionService";
  import GamePackService from "../services/GamePackService";
  import Card from "./Card";
  import InvestigatorActions from "./InvestigatorActions";
  import PickCard from "./PickCard";
  import CardService from "../services/CardService";
  import GameMenu from "./GameMenu";

  export default {
    components: {
      GameMenu,
      Card,
      InvestigatorActions,
      PickCard
    },

    data: () => ({
      tab: 0,
      form: {
        title: null
      },
      gamePacks: [],
      cardTypes: [],
      cardAttributeTypeSelection: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ]
    }),

    created() {
      this.viewGame(true);
      this.indexGamePacks();
      this.indexCardTypes();
    },

    watch: {
      tab: function () {
        if (this.$route.params.tab !== this.investigatorSessionIndex) {
          this.$router.push({name: 'game', params: {gameId: this.game.id, tab: this.investigatorSessionIndex}});
        }
      }
    },

    computed: {
      game() {
        return this.$store.getters.game;
      },

      options() {
        return {
          duration: 300,
          offset: 0,
          easing: 'easeInOutCubic',
        }
      },

      investigatorSessionIndex() {
        return this.tab - this.tabOffset;
      },

      tabOffset() {
        return 1;
      },

      filteredCardBacks() {
        if (this.investigatorSessionIndex < 0) return [];

        return this.game
          .activeInvestigatorSessions[this.investigatorSessionIndex]
          .cardBacks
          .filter(cardBack =>
            this.cardAttributeTypeSelection[this.investigatorSessionIndex].length <= 0 ||
            this.cardAttributeTypeSelection[this.investigatorSessionIndex].includes(cardBack.cardFront.cardType.title) ||
            cardBack.cardFront.reckoning && this.cardAttributeTypeSelection[this.investigatorSessionIndex].includes("Reckoning") ||
            cardBack.cardFront.cardAttributes.find(cardAttribute =>
              cardAttribute.cardAttributeTypes.find(cardAttributeType =>
                this.cardAttributeTypeSelection[this.investigatorSessionIndex].includes(cardAttributeType.title)
              )
            )
          );
      }
    },

    beforeRouteUpdate(to, from, next) {
      this.activateTab(to.params.tab);
      next();
    },

    methods: {
      indexCardTypes() {
        CardService.indexTypes()
          .then(response => {
            this.cardTypes = response.data.data;
          });
      },

      fillReserve() {
        GameService.fillReserve(this.game.id)
          .then(() => {
            this.viewGame();
          });
      },

      viewGame(created = false) {
        GameService.view(this.$route.params.gameId)
          .then(response => {
            this.$store.dispatch("setGameId", response.data.data.id);
            this.$store.dispatch("setGame", response.data.data);

            if (typeof this.$route.params.tab !== "undefined" && created) {
              this.activateTab(this.$route.params.tab);
            }
          })
          .catch(() => {
            this.$router.push({name: "home"});
          });
      },

      activateTab(tab) {
        if (tab < this.game.activeInvestigatorSessions.length) {
          this.tab = tab + this.tabOffset;
        }
      },

      cardGivenTo(investigatorSessionIndex) {
        this.tab = investigatorSessionIndex + this.tabOffset;
      },

      attachedCard() {
        this.viewGame();
        if (this.$route.params.tab !== this.investigatorSessionIndex) {
          this.$router.replace({name: 'game', params: {gameId: this.game.id, tab: this.investigatorSessionIndex}});
        }
        this.$vuetify.goTo(0);
      },

      detachedCard() {
        this.viewGame();
      },

      indexGamePacks() {
        GamePackService.index()
          .then(response => {
            this.gamePacks = response.data.data;
          });
      },

      storeInvestigatorSession() {
        this.form.game_id = this.$route.params.gameId;

        InvestigatorSessionService.store(this.form)
          .then(() => {
            this.form.title = null;
            this.viewGame();
          });
      },

      deleteInvestigator(investigatorSession) {
        if (confirm(`Are you sure you want to remove ${investigatorSession.title}?`)) {
          InvestigatorSessionService.delete(investigatorSession.id)
            .then(() => {
              this.viewGame();
              this.updateCards();
            });
        }
      },

      getFilterPart(investigatorSession, start) {
        let types = investigatorSession.cardTypes.concat(investigatorSession.cardAttributeTypes);
        return types.slice(start * 6, (start + 1) * 6);
      },

      increaseReserveSlots() {
        GameService.setReserveSlots(this.game.id, this.game.reserve_slots + 1)
          .then(response => {
            this.$store.dispatch("setReserveSlots", response.data.data.reserve_slots);
          });
      },

      decreaseReserveSlots() {
        GameService.setReserveSlots(this.game.id, this.game.reserve_slots - 1)
          .then(response => {
            this.$store.dispatch("setReserveSlots", response.data.data.reserve_slots);
          });
      }
    }
  }
  ;
</script>

<style>
    .v-slide-group__prev {
        display: none !important;
    }
</style>